/**
 * SearchContentContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled search content container.
 */
const SearchContentContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: column;
  left: ${316 * Screen.widthRatio}px;
  position: absolute;
  top: ${430 * Screen.widthRatio}px;
`;

export default SearchContentContainer;
